import Select from 'react-select'
import React, { useEffect, useRef, useState } from 'react'
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CButton,
  CNavLink,
  CFormTextarea,
  CSpinner,
  CAvatar,
  CImage,
  CAccordion,
  CAccordionBody,
  CAccordionItem,
  CAccordionHeader,
  CFormLabel,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react'

import PatientPersonalHistory from './PatientPersonalHistory'
import PatientInfoDisplay from './PatientInfoDisplay'
import PatientVitals from './PatientVitals'
import PatientMedication from './PatientMedication'
import PatientImaging from './PatientImaging'
import ShowDemographics from './Demographics'

import PatientHistoryForm from './PatientHistoryForm'
import PatientInternalNotes from './PatientInternalNotes'
import Addendum from './Addendum'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'

import DiagnosisAssessment from './DiagnosisAssessment'
import PatientAllergies from './PatientAllergies'
import PatientPsychiatryNote from './PatientPsychiatryNote'
import PatientFinalNote from './PatientFinalNote'
import PatientLabs from './PatientLabs'
import Summary from './Summary'
import { useDispatch, useSelector } from 'react-redux'
import Note from './Note'
import PatientMedications from '../../services/general/patientMedicationData.api'
import PatientImagingsCRUD from '../../services/general/patientImagingData'
import ImagingInformation from '../../services/general/ImagingAPI.api'
import ModifyPatientHistory from '../../services/general/modifyPatientHistory.api'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api'
import PatientOrder from './PatientOrder'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
// import ViewCallCenter from './ViewCallCenter';
import MedicineCRUD from '../../services/general/Medication.api'
import { TuneOutlined } from '@mui/icons-material'
import { motion } from 'framer-motion'
import { Check, CheckCircle, EllipsisVertical, Printer, Save } from 'lucide-react'
import PatientDataCRUD from '../../services/general/patientNoteData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import PatientFloatingButton from './PatientFloatingButton'
import { usePDF } from 'react-to-pdf'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Reports from './Reports'
import Loader from '../../components/shared/Loader'
import HPIQuestions from './HPIQuestions'
import Provider from './Provider'
import DetailNote from './DetailNote'
import SuperBill from './SuperBill'
import { Data } from '@react-google-maps/api'
import AddDiagnosisModal from './AddDiagnosisModal'
import PatientNoteViewInModal from './PatientNoteViewInModal'
import PastOrder from './PastOrder'
import SaveExtra from '../../services/general/saveExtraData.api'
import PatientPastNote from './PatientPastNote'
import FacilityCRUD from '../../services/general/getFacilityData.api'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import { sendUpdate } from '../../components/shared/StorageSync'

const APP_THEME_STORAGE_KEY = 'provio_theme'

const readPatientInfoTheme = () => document.documentElement.getAttribute('data-theme') || document.body.getAttribute('data-theme') || localStorage.getItem(APP_THEME_STORAGE_KEY) || 'dark'

const PatientInfo = ({
  saveDiagnosisData,
  creatingNewNote = false,
  setRowClicked,
  patientID,
  patientData,
  showBreadcrumbs = false,
  dataCallType,
  setDataId,
  noteID,
  breadCrumbText = 'Appointment',
  breadCrumbHref = '/home/appointment',
  setEditDataId,
  setDataCallType,
  noteStatus,
  showAllData = true,
  showNoteView = false,
  appointments,
  handleAddNoteId,
  setAppointmentDetails = false,
  isAllotedToProvider = false,
}) => {
  const [activeTab, setActiveTab] = useState(0)
  const [addDiagnosisModalVisible, setAddDiagnosisModalVisible] = useState(false)
  const [historyPersonalHistoryActiveTab, setHistoryPersonalHistoryActiveTab] = useState('pmhx')
  const [loading, setLoading] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [patientDiagnosis, setPatientDiagnosis] = useState([])
  const [allergiesList, setAllergiesList] = useState([])
  const [Notes, setNotes] = useState([])
  const [vitalsList, setVitalsList] = useState([])
  const [diagnosisAddedPinger, setDiagnosisAddedPinger] = useState(false)
  const [allHistory, setAllHistory] = useState([])
  const [allLabs, setAllLabs] = useState([])
  const [reRender, setReRender] = useState(false)
  const [patientOrders, setPatientOrders] = useState([])
  const [masterMedications, setMasterMedications] = useState([])
  const [newImagingAdded, setNewImagingAdded] = useState(false)
  const [newmedsAdded, setNewmedsAdded] = useState(false)
  const [newLabsAdded, setNewLabsAdded] = useState(false)
  const [isPatientPageLoading, setIsPatientPageLoading] = useState(false)
  const [theme, setTheme] = useState(readPatientInfoTheme)
  const [selectedRisks, setSelectedRisks] = useState({})
  const [selectedDifferentialDiagnosis, setSelectedDifferentialDiagnosis] = useState({})
  const [MasterDiagnosisData, setMasterDiagnosisData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [showComment, setShowComment] = useState(false)
  const [showSaveModel, setShowSaveModel] = useState(false)
  const [submitLoader, setSubmitLoader] = useState(false)
  const [histories, setHistories] = useState({
    pmhx: [],
    pshx: [],
    fh: [],
    sh: [],
  })

  useEffect(() => {
    const syncTheme = (event) => {
      setTheme(event?.detail?.theme || readPatientInfoTheme())
    }

    window.addEventListener('provio-theme-change', syncTheme)
    window.addEventListener('storage', syncTheme)

    return () => {
      window.removeEventListener('provio-theme-change', syncTheme)
      window.removeEventListener('storage', syncTheme)
    }
  }, [])
  const [patientTreatments, setPatientTreatments] = useState(null)
  const [diagnosisCode, setDiagnosisCodes] = useState({})
  const [noteView, setNoteView] = useState(false)
  const [signModel, setSignModel] = useState(false)
  const [appoinmentDate, setAppointmentData] = useState()
  const [selectedFacility, setSelectedFacility] = useState({})
  const [facilities, setFacilities] = useState([])
  const [showOrderPopUp, setShowOrderPopUp] = useState(true)
  const [addendum, setAddendum] = useState([])
  const [pastOrders, setPastOrders] = useState([])
  const [showOrderPopUpYN, setShowOrderPopUpYN] = useState(false)

  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' })
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const noteStructureRef = useRef({})

  const [medicationList, setMedicationList] = useState([])

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
      }))
      setFacilities(formattedData)
    } catch (e) {}
  }

  const patientSelected = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) {}
  }

  const updatePatientDiagnosis = async (patientID, diagnosis) => {
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
    patientDiagnosis = patientDiagnosis
      .split(',')
      .filter((diagnosis) => diagnosis.trim().length > 0)
      .map((diagnosis) => diagnosis.trim())

    diagnosis = diagnosis.split(',')

    let arr = [...patientDiagnosis, ...diagnosis]
    let mergedArr = [...new Set(arr)]
    let newDiagnosis = mergedArr.join(',')

    let patientAllData = await patientSelected(patientData)
    await ModifyPatientMap('UPDATE', patientID, newDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
  }

  const editPatientDiagnosis = async (patientID, oldDiagnosis, newDiagnosis) => {
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
      .split(',')
      .map((diagnosis) => diagnosis.trim())
      .filter((diagnosis) => diagnosis.length > 0)

    let updatedDiagnosis = patientDiagnosis.map((diagnosis) => (diagnosis === oldDiagnosis ? newDiagnosis : diagnosis))

    let finalDiagnosis = [...new Set(updatedDiagnosis)].join(',')

    let patientAllData = await patientSelected(patientData)

    await ModifyPatientMap('UPDATE', patientID, finalDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
  }

  const deletePatientDiagnosis = async (patientID, diagnosisToDelete) => {
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
      .split(',')
      .map((diagnosis) => diagnosis.trim())
      .filter((diagnosis) => diagnosis.length > 0)

    setRowClicked((p) => {
      const diagnosisArray = p.Diagnosis ? p.Diagnosis.split(',').map((item) => item.trim()) : []

      const updatedDiagnosisArray = diagnosisArray.filter((item) => item !== diagnosisToDelete)

      return {
        ...p,
        Diagnosis: updatedDiagnosisArray.join(', '),
      }
    })

    let updatedDiagnosis = patientDiagnosis.filter((diagnosis) => diagnosis !== diagnosisToDelete)
    if (noteStructureRef.current && noteStructureRef.current.metadata && noteStructureRef.current.metadata.diagnosisIds) {
      let response = await GetDiagnosisData('')
      response = JSON.parse(response.d)?.Data

      const filteredNoteDiagnosis = response?.find((id) => id.Name == diagnosisToDelete)
      noteStructureRef.current.metadata.diagnosisIds = noteStructureRef.current.metadata.diagnosisIds.filter((id) => id !== filteredNoteDiagnosis?.id)
      await PatientNoteDataCRUD('UPDATE', patientID.toString(), setDataId?.toString(), JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
    }

    let finalDiagnosis = updatedDiagnosis.join(',')
    let patientAllData = await patientSelected(patientData)

    await ModifyPatientMap('UPDATE', patientID, finalDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
    setDiagnosisAddedPinger((p) => !p)
    showOnlyNoteDiagnosis()
  }

  const fetchhDiagnosisMaster = async () => {
    let formattedDataDiagnosis
    formattedDataDiagnosis = await GetDiagnosisData()
    let allDiagnosisCodes = {}
    if (formattedDataDiagnosis) {
      formattedDataDiagnosis = JSON.parse(formattedDataDiagnosis?.d)?.Data
      for (const diagnosis of formattedDataDiagnosis) {
        allDiagnosisCodes[diagnosis.Name.trim()] = diagnosis.Code
      }
    }
    setDiagnosisCodes(allDiagnosisCodes)
    setMasterDiagnosisData(formattedDataDiagnosis)
  }

  const getPatientDiagnosis = async () => {
    let diagnosisData = await ModifyPatientMap('GETALL', patientID, '')

    let tempData = JSON.parse(diagnosisData.d)?.Data

    diagnosisData = tempData.filter((obj) => {
      if (patientID == obj.PatientID) {
        return obj
      }
    })
    let patientD = []
    try {
      patientD = diagnosisData[0]?.Diagnosis?.split(',')
    } catch (e) {}

    // setPatientDiagnosis(patientD) patient diagnosis was setting from here we have diagnosis note wise
    let plans = {}
    let assessment = {}
    patientD.forEach((item) => {
      ;((plans[item] = ''),
        (assessment[item] = {
          MobilityAssessment: {},
          POA: '',
          MorseScore: {},
          LabImaging: '',
          FreeType: '',
          selfCareAssessment: {},
        }))
    })

    // noteStructureRef.current = {
    //   ...noteStructureRef.current,
    //   plans,
    // }
    setDiagnosisData(diagnosisData)
  }

  const handleTabClick = (index) => {
    // autoSaveTreatsShell()
    setActiveTab(index)
  }

  // get patient history
  const getHistory = async () => {
    let allData = await ModifyPatientHistory('GET', patientID)
    let history = JSON.parse(allData?.d)
    setAllHistory(history?.Data)

    let allHistory = history?.Data
    return history?.Data
  }

  // const addScheduleAppointmentDatatoNote = async () => {
  //   if (noteStructureRef.current?.appointmentDetails || !setDataId || !appointments || !patientID || patientTreatments.length === 0) {
  //     return
  //   }
  //   let filterPatientAppointments = appointments && appointments.length > 0 && appointments.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled'))
  //   if (filterPatientAppointments.length > 0) {
  //     const findCurrentNoteScheduleData = filterPatientAppointments.find((item) => item.data.NoteID === setDataId)
  //     if (findCurrentNoteScheduleData) {
  //       noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         appointmentDetails: findCurrentNoteScheduleData,
  //       }
  //       await saveTreatsShell(false)
  //     }
  //   }
  // }

  // useEffect(() => {
  //   addScheduleAppointmentDatatoNote()
  // }, [noteStructureRef.current?.appointmentDetails, appointments, setDataId, patientID, patientTreatments])

  const SyncAppointmentData = (noteID) => {
    let filterPatient = appointments && appointments.length > 0 && appointments.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled') && !item.data.NoteID)

    try {
      if (filterPatient.length > 0) {
        if (noteID !== null || noteID !== undefined) {
          handleAddNoteId(noteID, filterPatient[0]?.appointmentId, patientID)
          // addScheduleAppointmentDatatoNote()
        }
      }
    } catch (error) {
      console.error('Error syncing appointment data:', error)
    }
  }
  // Get Patient Treatments

  const GetPatientTreatmentsNotes = async () => {
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)

      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data?.map((item) => {
          return {
            ...item,
            data: item?.data ? JSON.parse(item?.data) : {},
          }
        })

        // noteStructureRef.current = data[noteID]?.data
        // setSelectedRisks(data[noteID]?.data.riskFactors || {})
        noteStructureRef.current = data[noteID]?.data

        if (data?.length === 0) {
          let provideInformation = patientData.Diagnosis.split(',')

          let information = provideInformation.reduce((acc, item) => {
            acc[item] = ['Patient Added']
            return acc
          }, {})
          let assessment = {}

          patientDiagnosis.forEach((item) => {
            assessment[item] = {
              MobilityAssessment: {},
              POA: '',
              MorseScore: {},
              LabImaging: '',
              FreeType: '',
              selfCareAssessment: {},
            }
          })

          noteStructureRef.current = {
            ...noteStructureRef.current,
            information,
            assessment,
          }
        } else {
          SyncAppointmentData(data[noteID]?.id)
          if (data[noteID]?.data.orderFlag === false || noteID === 0 || data[noteID]?.status === 'Submitted' || (data[noteID]?.flag == 'true' && data[noteID]?.status == 'Draft') || data[noteID]?.status === 'Signed') {
            setShowOrderPopUp(false)
          }

          try {
            let filterPatient = appointments && appointments.length > 0 && appointments.filter((item) => item?.current?.Patient?.value === patientID && item?.data?.Status === 'Finish')
            let lastAppointmentDate = filterPatient?.[filterPatient.length - 1]?.data?.CreatedDate || null
            if (lastAppointmentDate) {
              const datePart = lastAppointmentDate.split('T')[0]
              const usFormattedDate = new Date(datePart).toLocaleDateString('en-US')
              setAppointmentData(usFormattedDate)
            } else {
              setAppointmentData(filterPatient?.[0]?.data?.StartTime || '')
            }
          } catch (error) {
            console.error('Error processing appointment data:', error)
            setAppointmentData(null)
          }
          // if (filterPatient.length > 0) {
          //   handleAddNoteId(data[noteID].id || null)
          // }

          if (!data[noteID]?.data.information) {
            noteStructureRef.current = {
              ...noteStructureRef.current,
              information: data[0]?.data.information || {},
            }
          }
          if (data[noteID]?.data.riskFactors) {
            setSelectedRisks(data[noteID]?.data.riskFactors || {})
          }

          // let assessment = {}

          // patientDiagnosis.forEach((item) => {
          //   assessment[item] = {
          //     MobilityAssessment: {},
          //     POA: "",
          //     MorseScore: {},
          //     LabImaging: "",
          //     FreeType: "",
          //   }
          // })
          // noteStructureRef.current = {
          //   ...noteStructureRef.current,
          //   assessment: assessment
          // }
        }

        setPatientTreatments(data)
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
    }
  }
  noteStructureRef.current = {
    ...noteStructureRef.current,
  }
  // patient imaging =================================================================>>>>
  const [render, setRender] = useState(false)
  const [imagingTypeList, setImagingTypeList] = useState([])
  const [imagingList, setImagingList] = useState([])

  const getData = async () => {
    try {
      const data = await ImagingInformation('GET_ALL')
      if (data) {
        const formattedData = JSON.parse(data.d)?.Data
        const allFormattedData = formattedData
          .filter((item) => item.Keywords !== '')
          .map((item) => {
            return {
              ...item,
              Keywords: JSON.parse(JSON.parse(item.Keywords)),
            }
          })
        setImagingTypeList(allFormattedData)
        setRender((p) => !p)
      }
    } catch (error) {
      console.error('Error fetching imaging data', error)
    }
  }

  const extractUniqueKeywords = (keywordsArray) => {
    const allKeywords = keywordsArray.flatMap((item) => item.keyword.split(',')).map((keyword) => keyword.trim())

    const uniqueKeywords = Array.from(new Set(allKeywords))

    return uniqueKeywords
  }

  // get master medications
  const GetMasterMedications = async () => {
    try {
      let allMedicines = await MedicineCRUD('GET')
      let formattedData = JSON.parse(allMedicines.d)?.Data
      if (formattedData) {
        formattedData = formattedData.map((item) => {
          let itemData = JSON.parse(item.Data)
          return {
            ...item,
            Data: {
              ...itemData,
              diagnoses: itemData.diagnoses.split(',').map((diagnosis) => diagnosis.trim()),
            },
          }
        })
        setMasterMedications(formattedData)
      }
    } catch (error) {
      console.error('Error fetching master medications:', error)
    }
  }

  // get patient imaging
  const GetPatientImagings = async () => {
    try {
      let formattedData = await PatientImagingsCRUD('GET', patientID.toString())
      if (formattedData) {
        formattedData = JSON.parse(formattedData.d)
        formattedData = formattedData.Data.map((item) => {
          const parsedData = JSON.parse(item.data)
          const matchingType =
            parsedData &&
            imagingTypeList.find((type) => {
              return type.Name.toString() === parsedData.name.toString()
            })
          return {
            ...item,
            data: {
              ...parsedData,
              keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
            },
          }
        })
        // formattedData.sort((a, b) => Number(a?.data?.priority || 0) - Number(b?.data?.priority || 0))
        // formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))
        formattedData.sort((a, b) => {
          const priorityA = Number(a?.data?.priority || 0)
          const priorityB = Number(b?.data?.priority || 0)

          if (priorityA !== priorityB) {
            return priorityA - priorityB // sortt by priority
          }

          const dateA = new Date(a?.date).getTime()
          const dateB = new Date(b?.date).getTime()

          return dateB - dateA // soort by date descending
        })

        setImagingList(formattedData)
        return formattedData
      }
    } catch (error) {
      console.error('Error fetching patient imaging data', error)
    }
  }

  // useEffect(() => {
  //   setIsPatientPageLoading(true)
  //   try {
  //     const fetchData = async () => {
  //       await getData();
  //       await GetMasterMedications()
  //       await getHistory()
  //       await GetPatientImagings();
  //       await getPatientVitals()
  //       await fetchMedications()
  //       await fetchPatientLabs()
  //       await fetchAllergies()
  //       await fetchhDiagnosisMaster()
  //       await fetchOrders()
  //       await GetPatientTreatmentsNotes()
  //     };
  //     fetchData();
  //   } catch (error) {
  //   }
  //   finally{
  //     setIsPatientPageLoading(false)
  //   }
  // }, [patientID, reRender]);

  useEffect(() => {
    const fetchPatientAllData = async () => {
      setIsPatientPageLoading(true)
      try {
        await Promise.all([getData(), GetMasterMedications(), getHistory(), GetPatientImagings(), getPatientVitals(), fetchMedications(), fetchPatientLabs(), fetchAllergies(), fetchhDiagnosisMaster(), fetchOrders(), GetPatientTreatmentsNotes()])
      } catch (error) {
        console.error('Error fetching patient data:', error)
      } finally {
        setIsPatientPageLoading(false)
      }
    }

    fetchPatientAllData()
  }, [patientID, reRender])

  useEffect(() => {
    GetPatientImagings()
  }, [render])
  // patient imaging =================================================================>>>>

  // all master imaging gets

  // all master imaging gets

  // patient vitals ============

  const getPatientVitals = async () => {
    let allVital = { PatientID: patientID }
    allVital = [allVital]
    let allData
    allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))
    allData = JSON.parse(allData.d) || {}
    setVitalsList(allData?.Data)
  }
  // patient vitals ============

  // patient labs ============

  // scroll
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const fetchPatientLabs = async () => {
    try {
      let formattedData
      formattedData = await PatientLabsCRUD('GET', patientID.toString())
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      formattedData.sort((a, b) => b.id - a.id)
      setAllLabs(formattedData)
      return formattedData
    } catch (error) {
      console.log(error)
    }
  }
  // patient labs ============

  //  <<<<<========= patient medications =================================================================>>>>>
  const fetchMedications = async () => {
    let formattedData
    formattedData = await PatientMedications('GET', patientID.toString())
    formattedData = JSON.parse(formattedData.d)
    formattedData = formattedData?.Data
    if (formattedData) {
      formattedData = formattedData.map((item) => {
        return {
          ...item,
          data: JSON.parse(item.data),
        }
      })
    }
    formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))
    setMedicationList(formattedData)
    return formattedData
  }
  //  <<<<<========= patient medications =================================================================>>>>>

  // patient allergies
  const fetchAllergies = async () => {
    try {
      let formattedData
      formattedData = await GetPatientAllergiesCRUD('GET', patientID)
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      setAllergiesList(formattedData)
    } catch (error) {}
  }
  // patient allergies

  // patient orders

  const fetchOrders = async () => {
    try {
      let formattedData
      formattedData = await PatientOrdersCRUD('GET', patientID)
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData.map((item, idx) => {
          return {
            ...item,
            medication: item.medication == '' ? [] : JSON.parse(item.medication),
            imaging: item.imaging.length > 0 ? JSON.parse(item?.imaging) : {},
            medication: item.medication ? JSON.parse(item.medication) : {},
            labs: item.labs.length > 0 ? JSON.parse(item?.labs) : {},
          }
        })
      }
      setPatientOrders(formattedData)
    } catch (error) {
      console.log(error)
    }
  }

  // patient orders

  const handleGetDiagnosis = async () => {
    // Simulate loading
    setLoading(true)
    await getPatientDiagnosis()
    setTimeout(() => {
      setLoading(false)
      // Add your logic here
    }, 2000)
  }

  useEffect(() => {
    handleGetDiagnosis()
  }, [patientID, diagnosisAddedPinger])

  // Define an array of nav links
  const navLinks = [
    // { title: 'FaceSheet', tab: 1 },
    { title: 'Demographics', tab: 0 },
    { title: 'Hospital Records', tab: 2 },
    { title: 'History', tab: 3 },
    { title: 'Internal Notes', tab: 4 },
    { title: 'Vitals', tab: 5 },
    { title: 'Allergies', tab: 13 },
    { title: 'Imaging', tab: 6 },
    { title: 'Labs', tab: 7 },
    { title: 'Medication', tab: 8 },
    { title: 'Reports', tab: 16 },
    { title: 'Psychiatry Note', tab: 17 },
    { title: 'Final Note', tab: 10 },
    { title: 'Past Order', tab: 9 },

    // { title: 'Orders', tab: 15 },

    // { title: 'HPI Questions', tab: 17 },
    { title: 'Addendum', tab: 18 },
    { title: 'Past Notes', tab: 20 },

    // { title: 'Treatment Plan', tab: 10 },
    // { title: 'Assessment', tab: 11 },
    // { title: 'Final Note', tab: 12 },
    // Add more nav links here
  ]

  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  useEffect(() => {
    dispatch({ type: 'set', sidebarShow: false })
    getFacilities()
  }, [])

  const handleInsertData = async () => {
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)

      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data?.map((item) => {
          return {
            ...item,
            data: item?.data ? JSON.parse(item?.data) : {},
          }
        })

        setEditDataId(data.length)
        setDataCallType('edit')
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
    }
  }

  const handleSaveModule = () => {
    if (patientTreatments && patientTreatments.length > 0) {
      let setUpID = patientTreatments[noteID]

      if (setUpID?.status === 'Submitted') {
        setShowSaveModel(true)
      } else if (setUpID?.status === 'Signed') {
        setSignModel(true)
      } else {
        saveTreatsShell()
      }
    } else {
      saveTreatsShell()
    }
  }
  const handleSubmitModule = () => {
    if (patientTreatments && patientTreatments.length > 0) {
      let setUpID = patientTreatments[noteID]
      if (setUpID?.status === 'Signed') {
        setSignModel(true)
      } else {
        submitNotes()
      }
    } else {
      submitNotes()
    }
  }

  useEffect(() => {
    const settingNoteIdFunc = async () => {
      // Only aded noteID if the key does not exist in the object
      if (noteStructureRef && noteStructureRef.current) {
        if (!Object.prototype.hasOwnProperty.call(noteStructureRef.current, 'noteID')) {
          noteStructureRef.current = {
            ...noteStructureRef.current,
            noteID: Number(noteID),
          }
        }
        await PatientNoteDataCRUD('UPDATE', patientID.toString(), setDataId, JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
      }
      if (noteStructureRef.current) {
        settingNoteIdFunc()
      }
    }
  }, [noteStructureRef.current])

  const saveTreatsShell = async (showAlert = true) => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      // DifferentialDiagnosis: null,
      noteID: Number(noteID),
    }
    if (patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit') {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      let setUpID = patientTreatments[noteID] && patientTreatments[noteID]?.id
      let statuToCurrentNoteSave = (patientTreatments[noteID] && patientTreatments[noteID]?.status) || 'Draft'
      let flag = (patientTreatments[noteID] && patientTreatments[noteID]?.flag) || 'false'

      await PatientDataCRUD('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), statuToCurrentNoteSave?.toString(), flag?.toString())
      await GetPatientTreatmentsNotes()
      if (showAlert) {
        toast.success('Successfully Saved', toastConfig)
      }
    } else {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Draft', 'false')
      if (showAlert) {
        toast.success('Successfully Note Created', toastConfig)
      }

      handleInsertData()
      await GetPatientTreatmentsNotes()
    }
  }

  // const addPersonalHistoriesInitially = async () => {
  //   const personalHistoryIDs = {};
  //   const surgical = await getPatientPersonalHistory('INSERT', patientID, 'SurgicalHistory', '', "No surgical hx found.");
  //   const family = await getPatientPersonalHistory('INSERT', patientID, 'FamilyHistory', '', "Noncontributory.");
  //   const social = await getPatientPersonalHistory('INSERT', patientID, 'SocialHistory', '', "Pt denies any hx of tobacco, alcohol or any illict drug use.");

  //   personalHistoryIDs.SurgicalHistory = JSON.parse(surgical.d).Data[0].Id;
  //   personalHistoryIDs.FamilyHistory = JSON.parse(family.d).Data[0].Id;
  //   personalHistoryIDs.SocialHistory = JSON.parse(social.d).Data[0].Id;

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     isInitialHistoriesAdded: true,
  //     metadata: {
  //       ...noteStructureRef.current.metadata,
  //       ...personalHistoryIDs
  //     },
  //   }

  //   await saveTreatsShell(false)
  // };

  // useEffect(() => {
  //   if (creatingNewNote && patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit' && !noteStructureRef.current.isInitialHistoriesAdded) {
  //     addPersonalHistoriesInitially();
  //   }
  // }, [patientTreatments])

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const handleAddMedicationData = async () => {
    let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
    let allData = JSON.parse(data?.d)

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
    if (!result) {
      // if (patientData?.Status === 'Follow Up' && noteID === 0) {
      if (true) {
        const finalHpiStructure = {
          [patientID]: {
            [noteID]: {
              HPI: {},
              medicationRemarksForSubjective: '',
              data: 'Greater than 50% of the total time was spent on coordinating care, reviewing labs, imaging, and speaking with nursing and ancillary staff.',
            },
          },
        }
        let data = await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
      }
    } else {
      console.log('insert the data here already')
    }
  }

  useEffect(() => {
    handleAddMedicationData()
  }, [])

  const autoSaveTreatsShell = async () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      // DifferentialDiagnosis: null,
      noteID,
    }

    if (patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit') {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      let setUpID = patientTreatments[noteID] && patientTreatments[noteID]?.id
      let status = patientTreatments[noteID] && patientTreatments[noteID]?.status
      let flag = patientTreatments[noteID] && patientTreatments[noteID]?.flag

      await PatientDataCRUD('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), status, flag)
      await GetPatientTreatmentsNotes()
    } else {
      const formattedJson = JSON.stringify(noteStructureRef.current)

      await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString())
      handleInsertData()
      await GetPatientTreatmentsNotes()
    }
  }

  const submitNotes = async () => {
    setSubmitLoader(true)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      // DifferentialDiagnosis: null,
      noteID,
    }

    const formattedJson = JSON.stringify(noteStructureRef.current)

    if (setDataId) {
      let setUpID = setDataId ? setDataId.toString() : patientTreatments[noteID] && patientTreatments[noteID]?.id
      await PatientDataCRUD('UPDATE', patientID.toString(), setDataId ? setDataId.toString() : setUpID.toString(), formattedJson, getFormattedDate().toString(), 'Submitted', 'true')
      setModalVisible(false)
      toast.success('Successfully Submitted', toastConfig)
    } else {
      await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Submitted', 'true')
      handleInsertData()
      setModalVisible(false)
      toast.success('Successfully Submitted', toastConfig)
    }

    await GetPatientTreatmentsNotes()

    setSubmitLoader(false)
    setModalVisible(false)
  }

  // const updateNoteStructure = (updatedScore, updatedDate, diagnosisName, scoreType) => {
  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     [scoreType]: {
  //       ...noteStructureRef.current[scoreType],
  //       [diagnosisName]: {
  //         date: updatedDate,
  //         score: updatedScore,
  //       },
  //     },
  //     assessment: {
  //       ...noteStructureRef.current.assessment,
  //       [diagnosisName]: {
  //         ...noteStructureRef.current.assessment[diagnosisName],
  //         ['MorseScore']: {
  //           date: updatedDate,
  //           score: updatedScore,
  //         },
  //       },
  //     },
  //   }
  // }

  const updateNoteStructure = (updatedScore, updatedDate, diagnosisName, scoreType) => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      [scoreType]: {
        ...(noteStructureRef.current?.[scoreType] || {}), // ensure object
        [diagnosisName]: {
          date: updatedDate,
          score: updatedScore,
        },
      },
      assessment: {
        ...(noteStructureRef.current?.assessment || {}), // ensure object
        [diagnosisName]: {
          ...(noteStructureRef.current?.assessment?.[diagnosisName] || {}), // ensure object
          ['MorseScore']: {
            date: updatedDate,
            score: updatedScore,
          },
        },
      },
    }
  }

  const submitTreatsShell = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
    }

    setModalVisible(true)
  }

  const showOnlyNoteDiagnosis = async () => {
    const diagnosisIds = noteStructureRef.current?.metadata?.diagnosisIds
    if (Array.isArray(diagnosisIds) && diagnosisIds.length > 0) {
      try {
        let response = await GetDiagnosisData('')
        response = JSON.parse(response.d)?.Data

        const filteredNoteDiagnosis = response?.filter((item) => diagnosisIds.includes(item.id))

        if (filteredNoteDiagnosis?.length > 0) {
          setPatientDiagnosis(filteredNoteDiagnosis.map((item) => item.Name))
        } else {
          setPatientDiagnosis([])
        }
      } catch (error) {
        setPatientDiagnosis([])
        console.error('Error fetching or filtering diagnosis data:', error)
      }
    } else {
      setPatientDiagnosis([])
    }
  }

  //
  const carryForwardData = async () => {
    if (!creatingNewNote) return
    const dataResponse = await PatientNoteDataCRUD('GET', patientID)
    const parsedData = JSON.parse(dataResponse?.d)?.Data
    const allNotes = parsedData.map((item) => ({
      ...item,
      data: item?.data ? JSON.parse(item?.data) : {},
    }))
    if (allNotes.length <= 1) return
    const lastNoteIndex = allNotes.length - 2 // get your prev data of added
    const newNoteIndex = allNotes.length - 1 // get your this note data of added
    const lastAddedNote = allNotes[lastNoteIndex]
    const newlyAddedNote = allNotes[newNoteIndex]
    const dataLastNote = lastAddedNote?.data
    let patientDiagnosisInLastNote
    const diagnosisIds = dataLastNote?.metadata?.diagnosisIds
    if (Array.isArray(diagnosisIds) && diagnosisIds.length > 0) {
      let response = await GetDiagnosisData('')
      response = JSON.parse(response.d)?.Data
      const filteredNoteDiagnosis = response?.filter((item) => diagnosisIds.includes(item.id))
      if (filteredNoteDiagnosis?.length > 0) {
        patientDiagnosisInLastNote = filteredNoteDiagnosis.map((item) => item.Name)
      }
    }
    const previousRiskFactors = dataLastNote?.riskFactors || {}
    const previousDDX = dataLastNote?.patientDifferentialDiagnosis || {}
    const previousAlert = dataLastNote?.alertData || {}
    const previousHistoryOfDiagnosis = dataLastNote?.historyOfDiagnosis || {}
    // Temporary object to hold only the relevant data
    const carryForwardObject = {
      historyOfDiagnosis: {},
      riskFactors: {},
      metadata: {
        diagnosisIds: dataLastNote?.metadata?.diagnosisIds || [],
      },
      patientDifferentialDiagnosis: {},
      alertData: {},
      assessment: {},
      plans: {},
    }
    patientDiagnosisInLastNote.filter(Boolean).forEach((diagnosis) => {
      const cleanedDiagnosis = diagnosis
      if (previousRiskFactors[cleanedDiagnosis]) {
        carryForwardObject.riskFactors[cleanedDiagnosis] = previousRiskFactors[cleanedDiagnosis]
        setSelectedRisks((prev) => ({
          ...prev,
          [cleanedDiagnosis]: previousRiskFactors[cleanedDiagnosis],
        }))
      }
      if (previousDDX[cleanedDiagnosis]) {
        carryForwardObject.patientDifferentialDiagnosis[cleanedDiagnosis] = previousDDX[cleanedDiagnosis]
      }
      if (previousAlert[cleanedDiagnosis]) {
        carryForwardObject.alertData[cleanedDiagnosis] = previousAlert[cleanedDiagnosis]
      }
      if (previousHistoryOfDiagnosis[cleanedDiagnosis]) {
        carryForwardObject.historyOfDiagnosis[cleanedDiagnosis] = previousHistoryOfDiagnosis[cleanedDiagnosis]
      }
      if (dataLastNote?.assessment?.[cleanedDiagnosis]?.FreeType) {
        carryForwardObject.assessment[cleanedDiagnosis] = {
          FreeType: dataLastNote.assessment[cleanedDiagnosis].FreeType,
        }
      }
      if (dataLastNote?.plans?.[cleanedDiagnosis]?.freeType) {
        carryForwardObject.plans[cleanedDiagnosis] = {
          freeType: dataLastNote.plans[cleanedDiagnosis].freeType,
        }
      }
    })
    noteStructureRef.current = {
      ...noteStructureRef.current,
      historyOfDiagnosis: carryForwardObject.historyOfDiagnosis,
      isCarryForward: true,
      riskFactors: carryForwardObject.riskFactors,
      patientDifferentialDiagnosis: carryForwardObject.patientDifferentialDiagnosis,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: carryForwardObject.metadata.diagnosisIds,
      },
      assessment: carryForwardObject.assessment,
      alertData: carryForwardObject.alertData,
      plans: carryForwardObject.plans,
    }
    await PatientNoteDataCRUD('UPDATE', patientID.toString(), newlyAddedNote?.id.toString(), JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
    await showOnlyNoteDiagnosis()
  }

  const historyTypeMapping = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const getPersonalHistoryData = async () => {
    let newHistories = {}

    // Loop through all history types
    for (const [key, historyType] of Object.entries(historyTypeMapping)) {
      try {
        const allData = await getPatientPersonalHistory('GET', patientID, historyType, '')
        const formattedData = JSON.parse(allData?.d)

        if (formattedData && formattedData.Data) {
          newHistories[key] = formattedData.Data
        }
      } catch (error) {
        console.error(`Error fetching ${historyType}:`, error)
        // You could optionally add fallback or error info to newHistories[key] = ...
      }
    }

    // Update all histories at once
    setHistories((prevHistories) => ({
      ...prevHistories,
      ...newHistories,
    }))
  }

  useEffect(() => {
    getPersonalHistoryData()
  }, [])

  useEffect(() => {
    carryForwardData()
  }, [])

  useEffect(() => {
    showOnlyNoteDiagnosis()
  }, [noteStructureRef.current?.metadata])

  const handleOrderFlag = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      orderFlag: false,
    }
    setShowOrderPopUp(false)
  }

  const addDiagnosisIdsToNote = async (ids) => {
    const existingIds = noteStructureRef.current.metadata?.diagnosisIds || []
    const combinedIds = [...existingIds, ...ids]
    const uniqueIds = Array.from(new Set(combinedIds))

    noteStructureRef.current = {
      ...noteStructureRef.current,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: uniqueIds,
      },
    }
    await saveTreatsShell(false)
  }

  const fetchAddendumData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'Addendum', '', '')

      data = JSON.parse(data?.d)?.Data || []

      data = data.map((item) => JSON.parse(item?.JsonData))
      data = data.reverse() // latest first

      const currentNoteID = noteID.toString()
      const noteIDNum = parseInt(noteID, 10)
      const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null

      const findPatientNoteData = (data, patientID, noteID) => {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]

          if (item[patientID]) {
            if (item[patientID][currentNoteID]) {
              return item[patientID][currentNoteID]
            }

            if (previousNoteID && item[patientID][previousNoteID]) {
              return item[patientID][previousNoteID]
            }
          }
        }
        return null
      }

      const result = findPatientNoteData(data, patientID, noteID)
      if (result) {
        setAddendum(result)
      } else {
        const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID
        console.warn(`Patient ${patientID} with note ${searchNotes} not found`)
        setAddendum(null)
      }
    } catch (error) {
      console.error('Failed to fetch addendum data:', error)
      setAddendum(null)
    }
  }

  // set all diagnosis or anything for quick in note structure
  // useEffect(()=>{
  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     metadata: {
  //       ...noteStructureRef.current.metadata,
  //       diagnosisIds :[97, 40, 56, 66, 88, 141, 85, 55, 142, 67, 65, 48, 90, 45, 68, 100, 113, 58, 150, 115, 51, 27, 71, 21, 127, 89, 95, 99, 91, 75, 101, 123, 23, 62, 139, 41, 63, 43, 103, 143, 140, 86, 87, 92, 125, 25, 64, 148, 108, 70, 107, 37, 34, 128, 93, 35, 105, 36, 42, 59, 50, 130, 74, 53, 116, 77, 39, 61, 20, 129, 117, 46, 69, 49, 124, 24, 126, 26, 52, 47, 112, 114, 109, 149, 38, 72, 132, 133, 131, 110, 134, 54, 144, 146, 145, 76, 106]
  //     }
  //   }
  //   saveTreatsShell(false)
  // },[])

  const fetchPastOrders = async () => {
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []

      const parsedOrders = data
        ?.map((order) => ({
          // ...order,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

      setPastOrders(parsedOrders)

      setShowOrderPopUpYN(parsedOrders?.length === 0 ? false : true)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  useEffect(() => {
    fetchAddendumData()
    fetchPastOrders()
    // fetcLocalData()
  }, [])

  const setPatientDiagnois = async (diagnosisJoined) => {
    let patientAllData = await patientSelected(patientData)
    await ModifyPatientMap('UPDATE', patientID, diagnosisJoined, patientAllData?.value)
  }

  const removeDiagnosisIdFromNote = async (diagnosiNameToRemove) => {
    setRowClicked((p) => {
      const diagnosisArray = p.Diagnosis ? p.Diagnosis.split(',').map((item) => item.trim()) : []

      const updatedDiagnosisArray = diagnosisArray.filter((item) => item !== diagnosiNameToRemove)

      return {
        ...p,
        Diagnosis: updatedDiagnosisArray.join(', '),
      }
    })

    // Fetch all diagnosis list
    let allDiagnosis = await GetDiagnosisData('')
    allDiagnosis = JSON.parse(allDiagnosis.d)?.Data

    // Filter from local patientDiagnosis list
    const filterPatientDiagnosis = patientDiagnosis.filter((item) => item !== diagnosiNameToRemove)

    setPatientDiagnosis(filterPatientDiagnosis)

    // Get idToRemove from name
    const idToRemove = allDiagnosis.find((item) => item.Name === diagnosiNameToRemove)?.id

    // Check and update metadata in noteStructureRef
    const existingIds = noteStructureRef.current.metadata?.diagnosisIds || []

    const updatedIds = existingIds.filter((id) => id !== idToRemove)

    await setPatientDiagnois(filterPatientDiagnosis.join(','))

    noteStructureRef.current = {
      ...noteStructureRef.current,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: updatedIds,
      },
    }

    await saveTreatsShell(false)

    await getPatientDiagnosis()

    await showOnlyNoteDiagnosis()
  }
  useEffect(() => {
    showOnlyNoteDiagnosis()
  }, [diagnosisAddedPinger])

  // setting any patient diagnosis to empty
  // useEffect(()=>{

  //   const setPatientDiagnois = async () => {
  //     let patientAllData = await patientSelected(patientData)
  //   await ModifyPatientMap("UPDATE", patientID, "", patientAllData?.value)
  //   }
  //   setPatientDiagnois()
  // },[])
  const pathname = window.location.pathname // e.g. "/home/provider/completed-appointment"
  const segments = pathname.split('/').filter(Boolean) // removes empty strings

  // Join the first 3 segments
  const baseRoute = segments.slice(0, 3).join('/')

  return (
    <>
      {isPatientPageLoading ? (
        <div data-theme={theme} className="appointment-patient-info-theme" style={{ height: '100vh', background: 'var(--ui-dashboard-bg, #040404)', width: '100%' }}>
          <Loader />
        </div>
      ) : !patientData ? (
        <div data-theme={theme} className="appointment-patient-info-theme" style={{ height: '100vh', background: 'var(--ui-dashboard-bg, #040404)', width: '100%' }}>
          <Loader />
        </div>
      ) : (
        <div data-theme={theme} className="patient-info-page appointment-patient-info-theme">
          <div className="mb-3">
            <CBreadcrumb hidden={showBreadcrumbs}>
              {/* <CBreadcrumbItem href={baseRoute === 'home/provider/completed-appointment' ? '/home/provider/completed-appointment' ? baseRoute === '/home/provider/appointment' ? "/home/provider/appointment" : baseRoute === 'home/provider/all-patients' ? '/home/provider/all-patients' : baseRoute === 'home/all-appointment' ? '/home/all-appointment' : '/home/appointment'}> */}
              <CBreadcrumbItem
                href={
                  baseRoute === 'home/provider/completed-appointment'
                    ? '/home/provider/completed-appointment'
                    : baseRoute === 'home/provider/appointment'
                      ? '/home/provider/appointment'
                      : baseRoute === 'home/provider/all-patients'
                        ? '/home/provider/all-patients'
                        : baseRoute === 'home/all-appointment'
                          ? '/home/all-appointment'
                          : '/home/appointment'
                }
              >
                {baseRoute === 'home/provider/completed-appointment'
                  ? 'Completed Appointment'
                  : baseRoute === 'home/provider/pending-appointment'
                    ? 'Pending Appointment'
                    : baseRoute === 'home/provider/appointment'
                      ? 'Provider Appointment'
                      : baseRoute === 'home/provider/all-patients'
                        ? 'All Patients'
                        : 'Appointment'}
              </CBreadcrumbItem>
              <CBreadcrumbItem active>Patient Info</CBreadcrumbItem>
            </CBreadcrumb>
          </div>
          {showAllData && (
            <CRow className="gap-4">
              <div className="d-flex gap-4">
                <CCol xs="1" className="" style={{ width: '12.666667%' }}>
                  <div style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }} className="custom-no-scroll">
                    <CNav vertical type className="flex-column" variant="pills">
                      {navLinks.map((link, index) => (
                        <CNavItem key={index} className="mb-3">
                          <CNavLink active={activeTab === link.tab} onClick={() => handleTabClick(link.tab)} href="#">
                            {link.title}
                          </CNavLink>
                        </CNavItem>
                      ))}
                    </CNav>
                  </div>
                </CCol>

                <PatientFloatingButton
                  addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                  handleToggleAddDiagnosis={() => {
                    setAddDiagnosisModalVisible((p) => !p)
                  }}
                  targetRef={targetRef}
                  toPDF={toPDF}
                  noteStructureRef={noteStructureRef}
                  saveTreatsShell={handleSaveModule}
                  submitTreatsShell={submitTreatsShell}
                  setNoteView={setNoteView}
                />

                <CCol xs={10} className="" style={{ height: activeTab === 18 ? 'auto' : '100vh' }}>
                  <CRow className="mb-3">
                    <CCard style={{ borderRadius: '10px', height: activeTab === 18 ? 'auto' : '90vh', overflow: activeTab === 18 ? 'visible' : 'auto' }}>
                      <CCardBody>
                        <div style={{ height: activeTab === 18 ? 'auto' : '100%', overflowY: activeTab === 18 ? 'visible' : 'auto' }}>
                          {activeTab === 0 && (
                            <div className="position-relative">
                              <ShowDemographics formData={patientData} diagnosis={diagnosisData}></ShowDemographics>
                            </div>
                          )}
                          {activeTab === 1 && (
                            <div className="position-relative">
                              <Summary setActiveTab={setActiveTab} vitalsList={vitalsList} patientData={patientData} />
                            </div>
                          )}
                          {activeTab === 2 && (
                            <div className="position-relative">
                              <PatientHistoryForm
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                allHistory={allHistory}
                                setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                                getHistory={getHistory}
                                setAllHistory={setAllHistory}
                                patientID={patientID}
                                loading={loading}
                                setLoading={setLoading}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientHistoryForm>
                            </div>
                          )}
                          {activeTab === 3 && (
                            <div className="position-relative">
                              <PatientPersonalHistory
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                                activeTab={historyPersonalHistoryActiveTab}
                                setActiveTab={setHistoryPersonalHistoryActiveTab}
                                patientID={patientID}
                                histories={histories}
                                setHistories={setHistories}
                                loading={loading}
                                setLoading={setLoading}
                                Notes={Notes}
                                setNotes={setNotes}
                                noteStructureRef={noteStructureRef}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientPersonalHistory>
                            </div>
                          )}
                          {activeTab === 18 && (
                            <div className="position-relative">
                              <Addendum patientID={patientID} noteID={noteID} />
                            </div>
                          )}
                          {activeTab === 4 && (
                            <div className="position-relative">
                              <PatientInternalNotes noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} Notes={Notes} setNotes={setNotes}></PatientInternalNotes>
                            </div>
                          )}
                          {activeTab === 5 && (
                            <div className="position-relative">
                              <PatientVitals noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} vitalsList={vitalsList} setVitalsList={setVitalsList}></PatientVitals>
                            </div>
                          )}
                          {activeTab === 8 && (
                            <div className="position-relative">
                              <PatientMedication
                                saveTreatsShell={saveTreatsShell}
                                noteID={noteID}
                                setNewmedsAdded={setNewmedsAdded}
                                patientID={patientID}
                                patientName={[patientData?.FirstName, patientData?.MiddleName, patientData?.LastName].filter(Boolean).join(' ')}
                                fetchMedications={fetchMedications}
                                loading={loading}
                                setLoading={setLoading}
                                medicationList={medicationList}
                                setMedicationList={setMedicationList}
                                noteStructureRef={noteStructureRef}
                                appoinmentDate={appoinmentDate}
                              ></PatientMedication>
                            </div>
                          )}
                          {activeTab === 13 && (
                            <div className="position-relative">
                              <PatientAllergies noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} allergiesList={allergiesList} setAllergiesList={setAllergiesList}></PatientAllergies>
                            </div>
                          )}
                          {activeTab === 16 && (
                            <div className="position-relative">
                              <Reports patientID={patientID} />
                            </div>
                          )}
                          {activeTab === 6 && (
                            <div className="position-relative">
                              <PatientImaging
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                setNewImagingAdded={setNewImagingAdded}
                                GetPatientImagings={GetPatientImagings}
                                setRender={setRender}
                                patientID={patientID}
                                setImagingList={setImagingList}
                                imagingTypeList={imagingTypeList}
                                loading={loading}
                                setLoading={setLoading}
                                imagingList={imagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                setShowComment={setShowComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientImaging>
                            </div>
                          )}
                          {activeTab === 9 && (
                            <div className="position-relative">
                              <PastOrder patientID={patientID} noteID={noteID} orders={pastOrders} />
                            </div>
                          )}
                          {activeTab === 15 && <div className="position-relative">{/* <PatientOrder patientID={patientID} fetchOrders={fetchOrders} patientOrders={patientOrders} setPatientOrders={setPatientOrders} /> */}</div>}
                          {activeTab === 10 && (
                            <div className="position-relative">
                              <Note
                                vitalsList={vitalsList}
                                isAllotedToProvider={isAllotedToProvider}
                                saveTreatsShell={saveTreatsShell}
                                setDataId={setDataId}
                                statusPatientNote={noteStatus || ''}
                                showComment={showComment}
                                targetRef={targetRef}
                                selectedRisks={selectedRisks}
                                setSelectedRisks={setSelectedRisks}
                                selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                                setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                                toPDF={toPDF}
                                masterMedications={masterMedications}
                                setMasterMedications={setMasterMedications}
                                GetMasterMedications={GetMasterMedications}
                                noteStructureRef={noteStructureRef}
                                hospitalRecords={allHistory}
                                setHospitalRecords={setAllHistory}
                                medication={medicationList}
                                setMedication={setMedicationList}
                                patientID={patientID}
                                diagnosisAddedPinger={diagnosisAddedPinger}
                                allergies={allergiesList}
                                setAllergies={setAllergiesList}
                                MasterDiagnosisData={MasterDiagnosisData}
                                imaging={imagingList}
                                setImaging={setImagingList}
                                newImagingAdded={newImagingAdded}
                                newLabsAdded={newLabsAdded}
                                newmedsAdded={newmedsAdded}
                                activeTab={historyPersonalHistoryActiveTab}
                                setActiveTab={setHistoryPersonalHistoryActiveTab}
                                patientData={patientData}
                                patientSidebarActiveTab={activeTab}
                                diagnosisCode={diagnosisCode}
                                patientTreatments={patientTreatments}
                                personalHistory={histories}
                                setPersonalHistory={setHistories}
                                allLabs={allLabs}
                                setReRender={setReRender}
                                patientDiagnosis={patientDiagnosis}
                                loading={loading}
                                imagingTypeList={imagingTypeList}
                                setLoading={setLoading}
                                imagingList={imagingList}
                                setImagingList={setImagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                noteID={noteID}
                                editPatientDiagnosis={editPatientDiagnosis}
                                deletePatientDiagnosis={deletePatientDiagnosis}
                                updateNoteStructure={updateNoteStructure}
                              ></Note>
                            </div>
                          )}
                          {activeTab === 7 && (
                            <div className="position-relative">
                              <PatientLabs
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                fetchPatientLabs={fetchPatientLabs}
                                setDataId={setDataId}
                                setNewLabsAdded={setNewLabsAdded}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                patientID={patientID}
                                allLabs={allLabs}
                                setAllLabs={setAllLabs}
                                loading={loading}
                                setLoading={setLoading}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientLabs>
                            </div>
                          )}
                          {activeTab === 20 && (
                            <div className="position-relative">
                              <PatientPastNote viewPatientDetail={patientData} patientTreatments={patientTreatments} noteID={noteID} />
                            </div>
                          )}

                          {activeTab === 17 && (
                            <div className="position-relative">
                              <PatientPsychiatryNote diagnosis={patientDiagnosis} />
                            </div>
                          )}
                          {/* {activeTab === 17 && (
                            <div className="position-relative">
                              <HPIQuestions diagnosis={patientDiagnosis} />
                            </div>
                          )} */}
                        </div>
                      </CCardBody>
                    </CCard>
                  </CRow>
                </CCol>
                <CModal size="lg" visible={modalVisible} backdrop={'static'} keyboard={false} onClose={() => setModalVisible(false)}>
                  <CModalHeader onClose={() => setModalVisible(false)}>
                    <CModalTitle>Note Details</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                    <DetailNote
                      setSubmitLoader={setSubmitLoader}
                      submitLoader={submitLoader}
                      isAllotedToProvider={isAllotedToProvider}
                      statusPatientNote={noteStatus && noteStatus === 'Follow Up' ? true : false}
                      handleSubmitModule={handleSubmitModule}
                      showHrsInTreatment={true}
                      showTreatmentAsAccordion={true}
                      showComment={showComment}
                      submitNotes={submitNotes}
                      setModalVisible={setModalVisible}
                      formData={patientData}
                      diagnosis={diagnosisData}
                      diagnosisCode={diagnosisCode}
                      noteStructureRef={noteStructureRef}
                      selectedRisks={selectedRisks}
                      setSelectedRisks={setSelectedRisks}
                      selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                      setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                      hospitalRecords={allHistory}
                      setHospitalRecords={setAllHistory}
                      medication={medicationList}
                      setMedication={setMedicationList}
                      patientID={patientID}
                      patientTreatments={patientTreatments}
                      newImagingAdded={newImagingAdded}
                      newLabsAdded={newLabsAdded}
                      newmedsAdded={newmedsAdded}
                      diagnosisAddedPinger={diagnosisAddedPinger}
                      allergies={allergiesList}
                      setAllergies={setAllergiesList}
                      patientDiagnosis={patientDiagnosis}
                      MasterDiagnosisData={MasterDiagnosisData}
                      imagingTypeList={imagingTypeList}
                      imaging={imagingList}
                      setImaging={setImagingList}
                      activeTab={historyPersonalHistoryActiveTab}
                      setActiveTab={setHistoryPersonalHistoryActiveTab}
                      patientData={patientData}
                      patientSidebarActiveTab={activeTab}
                      personalHistory={histories}
                      setPersonalHistory={setHistories}
                      allLabs={allLabs}
                      noteID={noteID}
                      showMedicationLikeApp={true}
                      noteStatus={noteStatus}
                      setDataId={setDataId}
                      addendum={addendum}
                    />
                  </CModalBody>
                </CModal>

                {/* <CCol xs={3} className='custom-scrollbar-container border  bg-white  ' style={{
                    overflowX: "hidden",
                    overflowY: "auto",
                    borderRadius: '10px',
                    // paddingRight: '8px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#c0c0c0 transparent',
                    height: '90vh'
                  }}>
                    <div className=' '>
                      <PatientFinalNote
                        statusPatientNote={noteStatus && noteStatus === "Follow Up" ? true : false}
                        diagnosisCode={diagnosisCode}
                        noteStructureRef={noteStructureRef}
                        selectedRisks={selectedRisks} setSelectedRisks={setSelectedRisks}
                        selectedDifferentialDiagnosis={selectedDifferentialDiagnosis} setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                        hospitalRecords={allHistory} setHospitalRecords={setAllHistory}
                        medication={medicationList} setMedication={setMedicationList}
                        patientID={patientID}
                        patientTreatments={patientTreatments}
                        newImagingAdded={newImagingAdded} newLabsAdded={newLabsAdded} newmedsAdded={newmedsAdded}
                        diagnosisAddedPinger={diagnosisAddedPinger}
                        allergies={allergiesList} setAllergies={setAllergiesList}
                        patientDiagnosis={patientDiagnosis}
                        MasterDiagnosisData={MasterDiagnosisData}
                        imagingTypeList={imagingTypeList}
                        imaging={imagingList} setImaging={setImagingList}
                        activeTab={historyPersonalHistoryActiveTab} setActiveTab={setHistoryPersonalHistoryActiveTab}
                        patientData={patientData} patientSidebarActiveTab={activeTab}
                        personalHistory={histories} setPersonalHistory={setHistories}
                        allLabs={allLabs}
                        noteShow={true} noteID={noteID}
                      ></PatientFinalNote>
                     
                    </div>
                  </CCol> */}
              </div>
              <div>
                <CModal size="xl" backdrop="static" visible={noteView} onClose={() => setNoteView(false)}>
                  <CModalHeader onClose={() => setNoteView(false)}>
                    <CModalTitle className="text-center w-100">Patient Note</CModalTitle>
                  </CModalHeader>
                  <CModalBody
                    style={{
                      height: '80vh',
                      overflowY: 'auto', // optional: adds scroll if content exceeds height
                    }}
                  >
                    <SuperBill
                      patientID={patientID}
                      statusPatientNote={noteStatus || ''}
                      showHrsInTreatment={true}
                      setDataId={setDataId}
                      showTreatmentAsAccordion={true}
                      showComment={showComment}
                      submitNotes={submitNotes}
                      setModalVisible={setModalVisible}
                      formData={patientData}
                      diagnosis={diagnosisData}
                      diagnosisCode={diagnosisCode}
                      noteStructureRef={noteStructureRef}
                      selectedRisks={selectedRisks}
                      setSelectedRisks={setSelectedRisks}
                      selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                      setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                      hospitalRecords={allHistory}
                      setHospitalRecords={setAllHistory}
                      medication={medicationList}
                      setMedication={setMedicationList}
                      patientTreatments={patientTreatments}
                      newImagingAdded={newImagingAdded}
                      newLabsAdded={newLabsAdded}
                      newmedsAdded={newmedsAdded}
                      diagnosisAddedPinger={diagnosisAddedPinger}
                      allergies={allergiesList}
                      setAllergies={setAllergiesList}
                      patientDiagnosis={patientDiagnosis}
                      MasterDiagnosisData={MasterDiagnosisData}
                      imagingTypeList={imagingTypeList}
                      imaging={imagingList}
                      setImaging={setImagingList}
                      activeTab={historyPersonalHistoryActiveTab}
                      setActiveTab={setHistoryPersonalHistoryActiveTab}
                      patientData={patientData}
                      patientSidebarActiveTab={activeTab}
                      personalHistory={histories}
                      setPersonalHistory={setHistories}
                      allLabs={allLabs}
                      noteID={noteID}
                      showMedicationLikeApp={true}
                    />
                  </CModalBody>
                </CModal>
                <AddDiagnosisModal
                  saveTreatsShell={saveTreatsShell}
                  showOnlyNoteDiagnosis={showOnlyNoteDiagnosis}
                  setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                  addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                  saveDiagnosisData={saveDiagnosisData}
                  patientData={patientData}
                  setAddDiagnosisModalVisible={setAddDiagnosisModalVisible}
                  addDiagnosisModalVisible={addDiagnosisModalVisible}
                  handleToggleAddDiagnosis={() => {
                    setAddDiagnosisModalVisible((p) => !p)
                  }}
                  patientID={patientID}
                  getPatientDiagnosis={getPatientDiagnosis}
                  updatePatientDiagnosis={updatePatientDiagnosis}
                  patientDiagnosis={patientDiagnosis}
                />

                <CModal size="md" backdrop="static" visible={showSaveModel} onClose={() => setShowSaveModel(false)}>
                  <CModalHeader>
                    <CModalTitle>Warning</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                    <p>This note has already been submitted. Are you sure you want to save it as a draft?</p>
                  </CModalBody>

                  <CModalFooter>
                    <CButton
                      onClick={() => {
                        ;(saveTreatsShell(), setShowSaveModel(false))
                      }}
                      variant="outline"
                      color="warning"
                    >
                      Save as Draft
                    </CButton>
                    <CButton
                      onClick={() => {
                        setShowSaveModel(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>

                <CModal size="md" backdrop="static" visible={signModel} onClose={() => setSignModel(false)}>
                  <CModalHeader>
                    <CModalTitle>Warning</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                    <p>This note has already been Signed. Are you sure you want to save it as a submit?</p>
                  </CModalBody>

                  <CModalFooter>
                    <CButton
                      onClick={() => {
                        ;(submitNotes(), setSignModel(false))
                      }}
                      variant="outline"
                      color="warning"
                    >
                      Save as Submit
                    </CButton>
                    <CButton
                      onClick={() => {
                        setSignModel(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>
              </div>

              {showOrderPopUpYN && (
                <CModal size="lg" backdrop="static" visible={showOrderPopUp} onClose={() => setShowOrderPopUp(false)}>
                  <CModalHeader>
                    <CModalTitle>Previous Order</CModalTitle>
                  </CModalHeader>
                  <CModalBody className="" style={{ maxHeight: '500px', overflow: 'auto' }}>
                    <PastOrder patientID={patientID} noteID={noteID} headerShow={false} orders={pastOrders} />
                  </CModalBody>

                  <CModalFooter className="mt-2">
                    <CButton variant="outline" onClick={() => handleOrderFlag()}>
                      Verified
                    </CButton>
                    <CButton
                      onClick={() => {
                        setShowOrderPopUp(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>
              )}
            </CRow>
          )}
          {showNoteView && patientTreatments && (
            <>
              <PatientNoteViewInModal
                patientID={patientID}
                statusPatientNoteWasFollowUp={noteStatus && noteStatus === 'Follow Up' ? true : false}
                showHrsInTreatment={true}
                setDataId={setDataId}
                setRowClicked={setRowClicked}
                showTreatmentAsAccordion={true}
                setAppointmentDetails={setAppointmentDetails}
                showComment={showComment}
                submitNotes={submitNotes}
                setModalVisible={setModalVisible}
                formData={patientData}
                diagnosis={diagnosisData}
                diagnosisCode={diagnosisCode}
                noteStructureRef={noteStructureRef}
                selectedRisks={selectedRisks}
                setSelectedRisks={setSelectedRisks}
                selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                hospitalRecords={allHistory}
                setHospitalRecords={setAllHistory}
                medication={medicationList}
                setMedication={setMedicationList}
                patientTreatments={patientTreatments}
                newImagingAdded={newImagingAdded}
                newLabsAdded={newLabsAdded}
                newmedsAdded={newmedsAdded}
                diagnosisAddedPinger={diagnosisAddedPinger}
                allergies={allergiesList}
                setAllergies={setAllergiesList}
                patientDiagnosis={patientDiagnosis}
                MasterDiagnosisData={MasterDiagnosisData}
                imagingTypeList={imagingTypeList}
                imaging={imagingList}
                setImaging={setImagingList}
                activeTab={historyPersonalHistoryActiveTab}
                setActiveTab={setHistoryPersonalHistoryActiveTab}
                patientData={{
                  ...patientData,
                  Status: noteID === 0 ? 'NewPatient' : 'Follow Up',
                }}
                patientSidebarActiveTab={activeTab}
                personalHistory={histories}
                setPersonalHistory={setHistories}
                allLabs={allLabs}
                noteID={noteID}
                showMedicationLikeApp={true}
                showToolbar={true}
                addendumData={addendum}
                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
              ></PatientNoteViewInModal>
            </>
          )}
        </div>
      )}
    </>
  )
}
export default PatientInfo
